import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { customerLogin, customerCreate, fetchCustomer } from "./ShopifyClient";
import StoreHeader from "./StoreHeader";

type Customer = {
  id?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
};

type AccountForm = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
};

function Account() {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState<string | null>(localStorage.getItem("customer_token"));
  const [customer, setCustomer] = useState<Customer | null>(null);
  const [form, setForm] = useState<AccountForm>({ email: "", password: "", firstName: "", lastName: "" });
  const [isSignup, setIsSignup] = useState(false);

  // Where to redirect after login/signup
  const from = (location.state as any)?.from?.pathname || "/";

  useEffect(() => {
    if (token) {
      fetchCustomer(token).then(setCustomer);
    }
  }, [token]);

  async function handleLogin(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const res = await customerLogin(form.email, form.password);
    if (res && res.customerAccessToken) {
      localStorage.setItem("customer_token", res.customerAccessToken.accessToken);
      setToken(res.customerAccessToken.accessToken);
      navigate(from, { replace: true }); // Redirect to previous page
    } else {
      alert("Login failed");
    }
  }

  async function handleSignup(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const res = await customerCreate(form.email, form.password, form.firstName, form.lastName);
    if (res && res.customer) {
      alert("Account created! You can now log in.");
      setIsSignup(false);
      // Optionally, you could automatically log in after signup:
      // await handleLogin(e);
    } else {
      const errors = res?.customerUserErrors?.map((err: any) => err.message).join(", ") || "Unknown error";
      alert("Signup failed: " + errors);
    }
  }

  function handleLogout() {
    localStorage.removeItem("customer_token");
    setToken(null);
    setCustomer(null);
  }

  if (customer) {
    return (
      <div className="container py-5 text-center">
        <h2>Welcome, {customer.firstName || customer.email}</h2>
        <p>Email: {customer.email}</p>
        <button className="btn btn-danger mt-3" onClick={handleLogout}>
          Logout
        </button>
      </div>
    );
  }

  return (
    <>
      <StoreHeader />
      <div className="container py-5">
        <h2 className="text-center">{isSignup ? "Create Account" : "Login"}</h2>
        <form
          onSubmit={isSignup ? handleSignup : handleLogin}
          className="mx-auto"
          style={{ maxWidth: 400 }}
        >
          {isSignup && (
            <>
              <input
                type="text"
                placeholder="First Name"
                className="form-control mb-2"
                value={form.firstName}
                onChange={(e) => setForm({ ...form, firstName: e.target.value })}
              />
              <input
                type="text"
                placeholder="Last Name"
                className="form-control mb-2"
                value={form.lastName}
                onChange={(e) => setForm({ ...form, lastName: e.target.value })}
              />
            </>
          )}
          <input
            type="email"
            placeholder="Email"
            className="form-control mb-2"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <input
            type="password"
            placeholder="Password"
            className="form-control mb-2"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          <button className="btn btn-primary w-100" type="submit">
            {isSignup ? "Sign Up" : "Login"}
          </button>
        </form>
        <p className="text-center mt-3">
          {isSignup ? (
            <>
              Already have an account?{" "}
              <button className="btn btn-link" onClick={() => setIsSignup(false)}>
                Login
              </button>
            </>
          ) : (
            <>
              Don’t have an account?{" "}
              <button className="btn btn-link" onClick={() => setIsSignup(true)}>
                Sign Up
              </button>
            </>
          )}
        </p>
      </div>
    </>
  );
}

export default Account;


